import loadable from '@loadable/component';
import {
  AboutContainer,
  CareersContainer,
  AboutCompanyContainer,
  AccountRecoveryContainer,
  AdvisorContainer,
  CompanyOverview,
  CompareCompanyContainer,
  DashboardContainer,
  DiscoverHubContainer,
  Maintenance,
  OffboardingContainer,
  OopsContainer,
  OTPLoginContainer,
  Plans,
  PodcastContainer,
  DeprecatedPortfolioContainer,
  DeprecatedPortfolioEditTxnContainer,
  DeprecatedPortfolioImportContainer,
  DeprecatedPortfolioReturnsContainer,
  DeprecatedPortfoliosContainer,
  PrivacyPolicyContainer,
  StocksContainer,
  StockScreenerContainer,
  TermsAndConditionsContainer,
  UserContainer,
  WatchlistContainer,
  WelcomeContainer,
  UserUnsubscribeContainer,
} from '@/containers';
import type { Components } from '@/reducers/page';
import { shallowEqual, useSelector } from 'react-redux';

const CompanySplit = loadable(() => import('@/pages/CompanySplit'));
const AffiliateProgram = loadable(() => import('@/pages/AffiliateProgram'));
const Article = loadable(() => import('@/pages/Article'));
const Market = loadable(() => import('@/pages/Market'));
const MarketHub = loadable(() => import('@/pages/MarketHub'));
const NotFound = loadable(() => import('@/pages/NotFound'));
const Portfolio = loadable(() => import('@/pages/Portfolio'));
const NewPortfolio = loadable(() => import('@/pages/NewPortfolio'));
const DefaultPortfolio = loadable(() => import('@/pages/DefaultPortfolio'));
const DiscoverPageV1 = loadable(() => import('@/pages/DiscoverPageV1'));
const DiscoverPageV2 = loadable(() => import('@/pages/DiscoverPageV2'));
const NarrativeCollection = loadable(
  () => import('@/pages/NarrativeCollection')
);

const Switcher = () => {
  const current = useSelector<
    { page: { current: Components[keyof Components] } },
    Components[keyof Components]
  >((state) => {
    return state.page.current;
  }, shallowEqual);

  switch (current) {
    case 'NotFound':
      return <NotFound />;
    case 'DiscoverHubContainer':
    case 'SamplePortfoliosContainer':
      return <DiscoverHubContainer />;
    case 'DiscoverPageV1':
      return <DiscoverPageV1 />;
    case 'DiscoverPageV2':
      return <DiscoverPageV2 />;
    case 'NarrativeCollection':
      return <NarrativeCollection />;
    case 'UserNotificationsContainer':
    case 'UserPlanContainer':
    case 'UserBetaLabContainer':
    case 'UserProfileContainer':
    case 'UserSubscriptionContainer':
      return <UserContainer />;
    case 'Plans':
      if (IS_NATIVE) {
        return <UserContainer />;
      } else {
        return <Plans />;
      }
    case 'AboutContainer':
      return <AboutContainer />;
    case 'CareersContainer':
      return <CareersContainer />;
    case 'AboutCompanyContainer':
      return <AboutCompanyContainer />;
    case 'AccountRecoveryContainer':
      return <AccountRecoveryContainer />;
    case 'AdvisorContainer':
      return <AdvisorContainer />;
    case 'CompanyOverview':
      return <CompanyOverview />;
    case 'CompanySplit':
      return <CompanySplit />;
    case 'CompareCompanyContainer':
      return <CompareCompanyContainer />;
    case 'DashboardContainer':
      return <DashboardContainer />;
    case 'Maintenance':
      return <Maintenance />;
    case 'OTPLoginContainer':
      return <OTPLoginContainer />;
    case 'OffboardingContainer':
      return <OffboardingContainer />;
    case 'OopsContainer':
      return <OopsContainer />;
    case 'PodcastContainer':
      return <PodcastContainer />;
    case 'DeprecatedPortfolioContainer':
      return <DeprecatedPortfolioContainer />;
    case 'DeprecatedPortfolioEditTxnContainer':
      return <DeprecatedPortfolioEditTxnContainer />;
    case 'DeprecatedPortfolioImportContainer':
      return <DeprecatedPortfolioImportContainer />;
    case 'DeprecatedPortfolioReturnsContainer':
      return <DeprecatedPortfolioReturnsContainer />;
    case 'DeprecatedPortfoliosContainer':
      return <DeprecatedPortfoliosContainer />;
    case 'PrivacyPolicyContainer':
      return <PrivacyPolicyContainer />;
    case 'StockScreenerContainer':
      return <StockScreenerContainer />;
    case 'StocksContainer':
      return <StocksContainer />;
    case 'TermsAndConditionsContainer':
      return <TermsAndConditionsContainer />;
    case 'WatchlistContainer':
      return <WatchlistContainer />;
    case 'WelcomeContainer':
      return <WelcomeContainer />;
    case 'Article':
      return <Article />;
    case 'MarketHub':
      return <MarketHub />;
    case 'Market':
      return <Market />;
    case 'UserUnsubscribeContainer':
      return <UserUnsubscribeContainer />;
    case 'AffiliateProgram':
      return <AffiliateProgram />;
    case 'Portfolio':
      return <Portfolio />;
    case 'NewPortfolio':
      return <NewPortfolio />;
    case 'DefaultPortfolio':
      return <DefaultPortfolio />;
    default:
      return <NotFound />;
  }
};
export default Switcher;
